const defaultTemplateText = `Hi {{name}} {{surname}},
Your invoice is ready. Please pay it by {{dueDate}}.

Thank you,
{{companyName}}

This email was sent using Ply`;
const templates = [
	// TODO // Get from store instead, this.defaultSelected or this.selectedEmailTemplate
	{ id: 1, title: 'Invoice template', value: defaultTemplateText, text: defaultTemplateText },
	{
		id: 4,
		title: 'Open reimbursement requests',
		value: `You have {{openRequestsNumber}} open requests as of {{date}} at {{time}}:

{{openRequests}}`,
		text: `You have {{openRequestsNumber}} open requests as of {{date}} at {{time}}:

{{openRequests}}`,
	},
	{
		id: 2,
		title: 'Successful sign-up email',
		value: `Hello {{name}}!\n You have successfully signed up to Ply!\nYou are the {{number}}nd person that works in {{industry}} to sign up to Ply`,
		text: `Hello {{name}}!\n You have successfully signed up to Ply!\nYou are the {{number}}nd person that works in {{industry}} to sign up to Ply`,
	},
	{ id: 3, title: 'Greeting email', value: 'Hello my name is {{name}}', text: 'Hello my name is {{name}}' },
];

const templatesMap = templates.reduce((acc, template) => {
	acc[template.id] = template;
	return acc;
}, {});

export const initialState = () => ({ selectedEmailTemplate: null, templates: templatesMap });

const state = initialState();

export default state;
